<template>
  <div>
    <g-invoice action-hook="updateInvoice" :is-edit-mode="true"/>
  </div>
</template>

<script>
import PageProgress from "../components/PageProgress";
import PageTitle from "../components/PageTitle";
import GPAutoComplete from "../components/GPAutoComplete";
import AddButton from "../components/buttons/AddButton";
import Validation from "../components/mixins/Validation";
import ConfirmPopup from "../components/popups/ConfirmPopup";
import CancelButton from "../components/buttons/CancelButton";
import ConfirmButton from "../components/buttons/ConfirmButton";
import ViewLiveLink from "../components/popups/ViewLiveLink";
import GInvoice from "../components/GInvoice";

export default {
  name: "EditInvoice",
  components: {
    GInvoice,
    ViewLiveLink,
    ConfirmButton,
    CancelButton, ConfirmPopup, AddButton, GPAutoComplete, PageTitle, PageProgress
  },
  mixins: [Validation],
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Panel - Edit Invoice | %s',
    meta: [
      {name: 'robots', content: 'noindex'},
      {name: 'googlebot', content: 'noindex'}
    ]
  }
}
</script>
